import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SSOSession = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant={'h3'}>{t('ssoAppSessionExchangeTitle')}</Typography>
      <Typography variant={'subtitle2'}>{t('ssoAppSessionExchangeTitle')}</Typography>
    </>
  );
};
